/* eslint-disable import/prefer-default-export */
import buildEnum from 'utils/buildEnum';

export const fieldIds = buildEnum(['location'], key => `assetLocation.${key}`);



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerLocatorPanel/constants.js